import React, { Component, Fragment } from 'react';
import { Route, Switch, withRouter, } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-image-gallery/styles/css/image-gallery.css'

import Layout from './component/Layout/Layout'
import Main from './component/Main'
import ContactUs from './component/ContactUs/ContactUs'
import Products from './component/Products/Products'
import ViewProduct from './component/Products/Product/ViewProduct'
import ShoppingCart from './component/ShoppingCart/ShoppingCart'
import Login from './component/Users/User/Login'
import Checkout from './component/Checkout/Checkout'

import { connect } from 'react-redux'
import * as actions from './store/actions/index'

import './App.css'

const baseUrl = process.env.PUBLIC_URL;

class App extends Component {

  _isMounted = false

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this._isMounted = true
    if (this._isMounted) {
      this.props.onTryAutoSignup();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    if (this.props.isAuthenticated) {
      this.props.onFetchCart()

    }
    let routes = (
      <Switch>
        <Route path={baseUrl + "/contactus"} render={props => <ContactUs {...props} />} />
        <Route path={baseUrl + '/products/product/:category/:id'} render={props => <ViewProduct {...props} />} />
        <Route path={baseUrl + '/products/:category/:subCategory'} render={props => <Products {...props} />} />
        <Route path={baseUrl + '/checkout'} component={Checkout} />
        <Route path={baseUrl + '/carts/'} render={props => <ShoppingCart {...props} />} />
        <Route path={baseUrl + '/login'} component={Login} />
        <Route path={baseUrl + '/'} exact component={Main} />
      </Switch>
    )

    return (
      <Fragment>
        <Layout>
          {routes}
        </Layout>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState()),
    onFetchCart:() => dispatch(actions.getAllCartService())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))

